import dagre from 'dagre';
import { Node, Edge } from '../types';

export const applyDagreLayout = (nodes: Node[], edges: Edge[]): Node[] => {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: 'TB', ranksep: 100, nodesep: 100 });

  // Add nodes to dagre graph
  nodes.forEach((node) => {
    // Use dynamic dimensions with fallbacks
    const width = node.width || 200;
    const height = node.height || 100;
    g.setNode(node.id, { width, height });
  });

  // Add edges to dagre graph
  edges.forEach((edge) => {
    g.setEdge(edge.source, edge.target);
  });

  // Apply layout
  dagre.layout(g);

  // Update node positions
  return nodes.map((node) => {
    const dagreNode = g.node(node.id);
    const width = node.width || 200;
    const height = node.height || 100;
    return {
      ...node,
      position: {
        x: dagreNode.x - width / 2, // Center the node based on actual width
        y: dagreNode.y - height / 2 // Center the node based on actual height
      }
    };
  });
};